/* eslint-disable jsx-a11y/no-static-element-interactions */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { last } from 'lodash';
import moment from 'moment';
import { momentizeAppointmentDates, sortAppointments } from '../../../../../../../../selectors/appointments';
import { navigate } from 'actionCreators';
import { ResourceCardElement } from 'components/ResourceCardElements';
import UserNote from 'components/UserNote';
import cx from 'classnames';
import { getMinLocalDate } from '../../../../../../../../utils/dateUtils';
import { formatTelephone, deriveStatusName, titleize } from '../../../../../../../../utils';
import { urls } from 'helpers/url';
import PhaseTypeSpan from 'styledComponents';
import DueDate from 'components/DueDate';
import FlagList from 'flagList';
import { PhaseIndexType } from 'types/phase';
import styles from 'styles/resourceCard';
import phaseCardStyles from '../phaseCard.scss';
import VendorLogo from 'components/VendorLogo';

class DesktopPhaseCard extends Component {
  onMouseDown = (e) => {
    this.startX = e.clientX;
    this.startY = e.clientY;
    this.distance = 0;
    this.dragging = true;
  }

  onMouseMove = (e) => {
    if (!this.dragging) return;
    this.distance = Math.sqrt(
      ((this.startY - e.clientY) ** 2) + ((this.startX - e.clientX) ** 2),
    );
  }

  onMouseUp = () => {
    if (!this.dragging) return;
    this.dragging = false;
    this.startX = 0;
    this.startY = 0;
    if (this.distance > 5) return;
    window.open(urls.phase(this.props.phase), '_blank');
  }

  determineCanCcsSchedule = (type, workroomSchedulable, phaseSchedulable, surfaceName) => (surfaceName !== 'Pro Direct' &&
    (type === 'Assessment' || (phaseSchedulable && type === 'Installation' && workroomSchedulable)));

  dragging = false
  distance = 0
  startX = 0
  startY = 0

  displayAssignedTo = (appointment = null) => {
    const {
      phase: {
        type,
        assigned_estimator_name = null,
        assigned_installer_name = null,
      },
    } = this.props;
    if (appointment) return appointment.assignee;
    if (type === 'Assessment') {
      const names = [assigned_estimator_name, assigned_installer_name].filter(Boolean);
      return names.length ? names.join(', ') : '--';
    }
    return assigned_installer_name || '--';
  }

  renderAppointmentDetails = (appt, phase) => {
    const zone = phase.workroom.timezone.includes('Central') ? ' CST ' : ' EST ';
    return (<span key={appt.id}>
      {moment(appt.start_date).format('MM/DD/YY')}
      {appt.end_date !== appt.start_date && `-${moment(appt.end_date).format('MM/DD/YY')}`}{' '}
      {moment(appt.arrival_start_time, 'HH:mm').format('h:mma')}
      -{moment(appt.arrival_end_time, 'HH:mm').format('h:mma')}{zone}
      {(appt.kind !== phase.type.toLowerCase() &&
       !(appt.kind === 'repair' && phase.type === 'Workorder')) &&
        `(${titleize(appt.kind)})`
      }
    </span>);
  };

  renderCcsSchedulable = type => <div>
    {type} <span style={{ color: 'red' }}>CCS Schedulable</span>
  </div>;

  render = () => {
    const { role, surfaceName, storeInfo, cardColorCode,
            motColorCode, motTitle, mot, phase, phase: {
              appointments = [], flags: phaseFlags = [], contractor_notes = '', workroom = null,
              recent_note = null, sqft = null, store = null, customer_name = '', street_address = '',
              city = '', state = '', zip_code = '', phone_numbers = [], product_type = '', source = '',
              effective_due_at = '', due_at = '', type = '', status_name = '', project_number = '', ccs_schedulable = null,
            } } = this.props;
    const workroomName = workroom ? workroom.name : '';
    const appts = sortAppointments(momentizeAppointmentDates(appointments));
    let appointmentIsPast = false;
    let appointment = appts.find(appt =>
      appt.end_moment.isSameOrAfter(moment().startOf('day')),
    );
    const contractorNotes = (contractor_notes || '--').substring(0, 70);
    const flags = phaseFlags;
    let extraFlagCount = 0;
    if (flags.length > 4) {
      extraFlagCount = flags.length - 4;
      flags.splice(0, extraFlagCount);
    }
    const flagsString = flags.join('');
    if (flagsString.length > 65) {
      flags.splice(0, 1);
      extraFlagCount += 1;
    }
    const flagTitle = extraFlagCount > 0 ? `flags (+${extraFlagCount})` : 'flags';
    if (!appointment) {
      appointment = last(appts);
      appointmentIsPast = true;
    }
    const noteTitle = recent_note ?
      `Latest Note - ${getMinLocalDate(recent_note.created_at)} By ${recent_note.user}` :
      'Latest Note';
    const surfaceString = sqft ? `${surfaceName} (${sqft}sqft)` : surfaceName;
    const canCcsSchedule = this.determineCanCcsSchedule(
      type, store.ccs_schedulable, ccs_schedulable, surfaceName,
    );
    const assignedTo = this.displayAssignedTo(appointment);
    return (<article
      onMouseDown={this.onMouseDown}
      onMouseMove={this.onMouseMove}
      onMouseUp={this.onMouseUp}
      onClick={this.navigate}
      className={phaseCardStyles.phaseLink}
    >
      <div
        className={cx(
          styles.aside,
          phaseCardStyles.aside,
          phaseCardStyles[cardColorCode],
        )}
      >
        <ResourceCardElement
          wrap
          title="Customer"
          size="full"
          theme={phaseCardStyles}
          className={phaseCardStyles.phaseCardAside}
        >
          <h5 className={phaseCardStyles.title}>{customer_name}</h5>
          <p className={cx(phaseCardStyles.customerInfo, phaseCardStyles.customerAddress)}>
            {street_address}<br />
            {city}, {state} {zip_code}
          </p>
          {phone_numbers[0] && <p className={phaseCardStyles.customerInfo}>
            {formatTelephone(phone_numbers[0].number)}
          </p>}
          <p className={phaseCardStyles.productType}>{product_type}</p>
        </ResourceCardElement>
        <div className={phaseCardStyles.dueDate}>
          <DueDate
            date={effective_due_at}
            showText={false}
            isPhaseDetails={false}
          />
          {due_at !== effective_due_at && <span>
            <strong> - Flag Due</strong>
          </span>}
          <VendorLogo
            workroomName={workroomName}
            source={source}
            styling={phaseCardStyles.vendorSourceImg}
          />
        </div>
      </div>
      <div className={phaseCardStyles.phaseRowFlex}>
        <div className={phaseCardStyles.phaseCardColumn}>
          <div className={styles.column}>
            <PhaseTypeSpan>
              <ResourceCardElement
                title="Phase Type"
                size="small"
                theme={phaseCardStyles}
                phaseType={type}
              >
                {canCcsSchedule ? this.renderCcsSchedulable(type) : type}
              </ResourceCardElement>
            </PhaseTypeSpan>
          </div>
          <div className={styles.column}>
            <ResourceCardElement
              title="Status"
              size="medium"
              value={deriveStatusName(status_name, { source, workroom: workroomName })}
              theme={phaseCardStyles}
            />
            <ResourceCardElement
              title="Store #"
              size="medium"
              theme={phaseCardStyles}
              value={storeInfo.number}
            />
            <ResourceCardElement
              title="Project #"
              size="medium"
              theme={phaseCardStyles}
              value={project_number}
            />
          </div>
          <div className={styles.column}>
            <ResourceCardElement
              title={motTitle}
              size="small"
              value={mot}
              className={phaseCardStyles[motColorCode]}
              theme={phaseCardStyles}
            />
            <ResourceCardElement
              title="Surface Type"
              size="small"
              value={surfaceString}
              theme={phaseCardStyles}
            />
            <ResourceCardElement
              title="Assigned To"
              size="small"
              theme={phaseCardStyles}
            >
              {assignedTo}
            </ResourceCardElement>
          </div>
          <div className={styles.column}>
            <ResourceCardElement
              wrap
              title={appointmentIsPast ? 'Last Appointment' : 'Next Appointment'}
              size="small"
              theme={phaseCardStyles}
            >{appointment ? this.renderAppointmentDetails(appointment, phase) : '--'}</ResourceCardElement>
            {phase.lrrp_required && <ResourceCardElement
              theme={phaseCardStyles}
              className={phaseCardStyles.lrrpRequired}
            >
              {'LRRP Required'}
            </ResourceCardElement>}
          </div>
        </div>
        <div className={phaseCardStyles.phaseCardColumn}>
          <div className={phaseCardStyles.phaseNoteContainer}>
            {role !== 'installer' && <ResourceCardElement
              wrap noFlexMobile
              title={flagTitle}
              size="large"
              theme={phaseCardStyles}
              className={phaseCardStyles.flagsCard}
            >
              <FlagList flags={flags} />
              {flags.length === 0 && '--'}
            </ResourceCardElement>}
            <ResourceCardElement
              wrap noFlexMobile
              title="Contractor Notes"
              size="large"
              theme={phaseCardStyles}
              className={phaseCardStyles.noteCard}
            >{contractorNotes}</ResourceCardElement>
            <ResourceCardElement
              wrap noFlexMobile
              title={noteTitle}
              size="large"
              theme={phaseCardStyles}
              className={phaseCardStyles.noteCard}
            >
              {recent_note ? (<UserNote>
                {recent_note.data.note}
              </UserNote>) : ('--')}
            </ResourceCardElement>
          </div>
        </div>
      </div>
    </article>);
  }
}

DesktopPhaseCard.propTypes = {
  role: PropTypes.string,
  position: PropTypes.string,
  phase: PhaseIndexType.isRequired,
  surfaceName: PropTypes.string,
  storeInfo: PropTypes.shape({
    number: PropTypes.string,
  }),
  cardColorCode: PropTypes.string.isRequired,
  motColorCode: PropTypes.string.isRequired,
  motTitle: PropTypes.string.isRequired,
  mot: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  navigate: PropTypes.func.isRequired,
};

export default connect(() => ({}), { navigate })(DesktopPhaseCard);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseList/components/phaseCard/components/desktopPhaseCard.jsx